import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Ricerca',
  },
  searchResults: {
    showMore: 'Mostra più risultati',
    noResults: 'Ci dispiace, non è stato possibile trovare alcun risultato per la tua ricerca <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® o PEFC',
      ecofriendly: 'Materiali ecologici',
      overnight: 'Express e Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Crea online',
    },
    taglines: {
      home: 'Scopri di più',
      text: 'Scopri di più',
      themes: 'Scopri di più',
      external: 'Scopri di più',
      info: 'Scopri di più',
      category: 'Scopri di più',
      content: 'Scopri di più',
      product: 'Configura ora',
    },
    headings: {
      categories: 'Categorie di prodotti',
      products: 'Prodotti',
      external: 'Ulteriori informazioni',
    },
    slider: {
      previousSlide: 'Mostra contenuto precedente',
      nextSlide: 'Mostra contenuto successivo',
    },
  },
  searchInput: {
    inputTooShortError: 'Il termine di ricerca è troppo breve (minimo 2)',
    results: 'Risultati',
    result: 'Risultato',
    youSearchFor: 'Risultati relativi a',
    suggestedTerm: {
      didYouMean: 'Intendevi',
      resultsFor: 'Cerca invece',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Visualizzazione elenco',
      gridButtonTooltip: 'Vista a riquadri',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Cancella tutti i filtri',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filtri',
        buttonsTooltipLabel: 'Visualizza',
        resultLabel: 'Risultati di ricerca',
      },
      contexts:
        {
          product: 'Prodotto',
          content: 'Miscellanea',
          all: 'all',
          category: 'Categorie di prodotti',
          external: 'Ulteriori informazioni',
        },
    },
    breadcrumbs: {
      start: 'Inizio',
      search: 'Ricerca',
    },
  },
  sideBar: {
    filter: 'Filtro',
    filterOverwrite: {
      category: {
        text: 'Categorie',
      },
      rootCategory: {
        text: 'Categorie',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Progettazione in linea',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'La tua sessione è scaduta e devi accedere di nuovo. Sarai reindirizzato al login immediatamente.',
      server403: 'La richiesta non è stata applicata perché mancano le credenziali di autenticazione valide. Si prega di ricaricare la pagina o di contattare il nostro servizio clienti.',
      default: 'Si è verificato un errore sul server. Si prega di ricaricare la pagina o di contattare il nostro servizio clienti.',
    },
    errors: {
      server400: 'La richiesta era malformata. Si prega di ricaricare la pagina o di contattare il nostro servizio clienti.',
      server404: '404 Pagina non trovata. Per favore vai alla pagina precedente o contatta il nostro servizio clienti',
      server500: 'Si è verificato un errore sul server. Per favore ricarica la pagina o contatta il nostro servizio clienti',
      server501: 'Si è verificato un errore sul server. Per favore ricarica la pagina o contatta il nostro servizio clienti',
      server502: 'Si è verificato un errore sul server e si ottiene una risposta non valida. Per favore ricarica la pagina o contatta il nostro servizio clienti',
      server503: 'Si è verificato un errore sul server. Per favore ricarica la pagina o contatta il nostro servizio clienti',
      server504: 'Si è verificato un errore sul server. Per favore ricarica la pagina o contatta il nostro servizio clienti',
      default: 'Il server ha un problema con la richiesta. Si prega di ricaricare la pagina o di contattare il nostro servizio clienti.',
    },
  },
};
export default translation;
